/**
 * Utility functions for handling quick date range selections
 * Use these functions in all analytics sub-pages for consistent date range handling
 */

export const getQuickDateRange = (range: string): { startDate: string; endDate: string } => {
  const today = new Date();
  const start = new Date();
  const end = new Date(today);

  switch (range) {
    case 'LAST_7_DAYS':
      start.setDate(today.getDate() - 7);
      break;
    case 'LAST_30_DAYS':
      start.setDate(today.getDate() - 30);
      break;
    case 'THIS_MONTH':
      start.setDate(1);
      end.setDate(1);
      end.setMonth(end.getMonth() + 1);
      end.setDate(end.getDate() - 1);
      break;
    case 'PREVIOUS_MONTH':
      start.setMonth(today.getMonth() - 1);
      start.setDate(1);
      end.setDate(1);
      end.setDate(end.getDate() - 1);
      break;
    case 'THIS_SEASON':
      // Season starts on April 10th each year
      // Season runs from April 10, YYYY to April 9, YYYY+1
      const currentYear = today.getFullYear();
      const currentMonth = today.getMonth(); // 0-11 (0 = January, 3 = April)
      const currentDay = today.getDate();
      
      // Check if we're before April 10th of current year
      if (currentMonth < 3 || (currentMonth === 3 && currentDay < 10)) {
        // We're in the previous season (started April 10 of previous year)
        start.setFullYear(currentYear - 1);
        start.setMonth(3); // April (0-indexed)
        start.setDate(10);
        end.setFullYear(currentYear);
        end.setMonth(3); // April
        end.setDate(9);
      } else {
        // We're in the current season (started April 10 of current year)
        start.setFullYear(currentYear);
        start.setMonth(3); // April
        start.setDate(10);
        end.setFullYear(currentYear + 1);
        end.setMonth(3); // April
        end.setDate(9);
      }
      break;
    default:
      // Return current date range if unknown
      start.setDate(today.getDate() - 30);
  }

  return {
    startDate: start.toISOString().split('T')[0],
    endDate: end.toISOString().split('T')[0],
  };
};

